import type { FighterDef } from './content'
import { runtimePublicPath } from './runtimePublicPath'

export const VAELTHAR_FIGHTER_ID = 'vaelthar-astral-architect'
export const VAELTHAR_RUNTIME_MODEL = 'vaelthar-astral-architect.glb'

export const VAELTHAR_FIGHTER: FighterDef = {
  id: VAELTHAR_FIGHTER_ID,
  name: 'Vaelthar',
  title: 'The Astral Architect',
  assetId: VAELTHAR_FIGHTER_ID,
  modelUrl: runtimePublicPath('/elyon/runtime-fighters/' + VAELTHAR_RUNTIME_MODEL),
  accent: '#B44EFF',
  maxHealth: 1180,
  speed: 7.15,
  power: 1.18,
  scale: 1.02,
  hurtHalfWidth: .62,
}

export function withVaeltharFighter(fighters: FighterDef[]): FighterDef[] {
  const without = fighters.filter(f => f.id !== VAELTHAR_FIGHTER_ID)
  return [...without, VAELTHAR_FIGHTER]
}

export function resolveVaeltharRuntimeModel(id: string) {
  return id === VAELTHAR_FIGHTER_ID ? VAELTHAR_RUNTIME_MODEL : null
}
